import { FaLock } from 'react-icons/fa'
import { FormattedMessage } from 'react-intl'
import Layout from '../components/Layout/Layout'

export default function NoAuthorization() {
    return (
        <Layout>
            <div style={{ display: "flex", alignContent: "center", justifyContent: "center", alignItems: "center", height: "100%", flexDirection: "column" }}>
                <h1 style={{ marginBottom: "2em" }}><b><FormattedMessage id="Screens.NoAuthorization.Title"/></b></h1>
                <FaLock size={100} style={{ color: "var(--main-color)" }} />
            </div>

        </Layout>
    )
}
